import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { OrderDeliveryInfoBlockComponent } from './components/order-delivery-info-block/order-delivery-info-block.component';
import { OrderCustomerInfoBlockComponent } from './components/order-customer-info-block/order-customer-info-block.component';

/**Reusable order information blocks, shared by the order overview and the offer pages */
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
  ],
  exports: [
    OrderDeliveryInfoBlockComponent,
    OrderCustomerInfoBlockComponent,
  ],
  declarations: [
    OrderDeliveryInfoBlockComponent,
    OrderCustomerInfoBlockComponent,
  ]
})
export class OrderInfoBlocksModule {
}
